import { Container, Form } from "react-bootstrap"
import Chart from "chart.js/auto"
import { useEffect, useState } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'
const request = new Request(process.env.apiDomain)

export default function ActivityMonthlyProgress(props) {
    
    const auth = props.props.auth;
    const contactId = auth.site_user ? auth.contactId : null;
    const [year, setYear] = useState(new Date().getFullYear())

    const [points, setPoints] = useState([]);
    const {data: profile} = request.contacts.swrAccount(contactId)
    const contact_id = profile ? parseInt(profile.contact_id) : null
    const { data: monthly} = request.stats.monthlyStats(contact_id,year);
    console.log('monthly:',monthly);

    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    const currentYear = new Date().getFullYear(); //Current Year
    const years = range(currentYear, currentYear - 2, -1); 

    function fetch(){

        let arr = [];

        // Get monthly statistics
        const monthlyStatistics = monthly ? JSON.parse(monthly.stats) : []

        Object.keys(monthlyStatistics).map((data, index) => {
            const point = parseInt(monthlyStatistics[data].points);
            arr.push(point);
        })

        if(arr.length > 0){
            setPoints(arr)
        }
       
    }

    useEffect(() => {
        fetch();
    }, [monthly])



    useEffect(() => {
        
        let config = {
        
            type: "bar",
            data: {
              labels: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ],
              datasets: [
                {
                  backgroundColor: "#43a649",
                  borderColor: "#43a649",
                  data: points,
                  fill: false,
                  barThickness: 25,
                },
                
              ],
            },
            options: {
              maintainAspectRatio: false,
              responsive: true,
              plugins:{
                legend: {
                  display: false
                },
              },
              scales: {
                x: {
                  grid: {
                    display: false,
                    drawBorder: false,
                  },
                },
                y: {
                  beginAtZero: true,
                  grid: {
                    display: true,
                    drawBorder: true,
                  },
                  ticks:{
                    display: true,
                  }
                },
              }
            },
          };


        if(points.length > 0){
            if(window.myBar instanceof Chart){
                window.myBar.destroy();
            }

            let ctx = document.getElementById("bar-chart").getContext("2d");
            window.myBar = new Chart(ctx, config);

        }
        
    }, [points])

    const onChangeHandler = (e) =>{
        setYear(parseInt(e.target.value))
    }


    return(
        <div className="activity-monthly-progress">
          <Container className="py-5">

            <Form className="form-inline">
                <Form.Group controlId="year">
                <h4 className="my-lg-5 my-2 font-weight-bold">Monthly Progress:&nbsp;</h4>
                <Form.Control
                  as="select"
                  name="year"
                  onChange={(e) => onChangeHandler(e)}
                >
                {
                    years.map((yr, idx) => (
                        <option key={idx} value={yr}>{yr}</option>
                    ))
                }
                </Form.Control>
              </Form.Group>

            </Form>

              <div className="position-relative">
                <canvas id="bar-chart"></canvas>
            </div>
          </Container>
          <hr className="divider mx-auto "/>
          <style jsx global>{`
              canvas{
                  height:300px!important;
                  width:100%!important;
              }
          `}</style>
        </div>
    )
};

